import { StyleSheet } from '@/core/StyleSheet';

export const getButtonStyle = (type: string) => {
	let backgroundColor: string;
	let color: string;

	switch (type) {
		case 'white':
			backgroundColor = 'white';
			color = StyleSheet.value('$textColor');
			break;

		case 'mint':
			backgroundColor = '#CDE0DE';
			color = '#589792';
			break;

		case 'primary':
			backgroundColor = StyleSheet.value('$colorBrandPrimary');
			color = 'white';
			break;

		case 'secondary':
			backgroundColor = StyleSheet.value('$colorBrandSecondary');
			color = 'white';
			break;

		case 'tertiary':
			backgroundColor = StyleSheet.value('$colorBrandTertiary');
			color = 'white';
			break;

		case 'quaternary':
		default:
			backgroundColor = StyleSheet.value('$colorBrandQuaternary');
			color = 'white';
			break;
	}

	return {
		backgroundColor,
		color,
	};
};
